// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"c98b5a5b","246":"8ee28cfb","453":"0eec3410","456":"1354b1b9","994":"f61a438c"}[chunkId] + ".chunk.js";
};